// settings 저장소 (기획서 7.6). 단일 레코드 id="global".
import { idbGet, idbPut } from './schema.js';

const CURRENT_SCHEMA_VERSION = 1;

export const DEFAULT_SETTINGS = {
  id: 'global',
  schemaVersion: CURRENT_SCHEMA_VERSION,
  theme: 'sepia', // 기획서 6.1 기본: 세피아
  fontFamily: 'serif', // 6.2 기본: 세리프
  fontSize: 16, // 6.3 기본 16 (모바일은 런타임에서 15 적용)
  lineHeight: 1.85, // 6.4 기본
  contentWidth: 'normal',
  layoutMode: 'single', // MVP-1 단페이지 강제
  immersionMode: true, // 6장/4.3 몰입 모드 기본
  updatedAt: Date.now(),
};

// schemaVersion 확인 → 구버전이면 마이그레이션 (기획서 7.6, 9.2)
function migrate(stored) {
  if (!stored) return { ...DEFAULT_SETTINGS };
  let s = { ...DEFAULT_SETTINGS, ...stored };
  if (s.schemaVersion < CURRENT_SCHEMA_VERSION) {
    // 향후 버전 변경 시 단계별 변환 추가. 현재는 누락 필드 기본값 보강만.
    s.schemaVersion = CURRENT_SCHEMA_VERSION;
  }
  return s;
}

export async function loadSettings() {
  const stored = await idbGet('settings', 'global');
  const migrated = migrate(stored);
  if (!stored || stored.schemaVersion !== CURRENT_SCHEMA_VERSION) {
    await idbPut('settings', migrated);
  }
  return migrated;
}

export async function saveSettings(settings) {
  const next = { ...settings, id: 'global', updatedAt: Date.now() };
  await idbPut('settings', next);
  return next;
}
